import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '../views/Dashboard/Dashboard.vue';
import Analytics from '../views/modules/Analytics/Analytics.vue';
import Login from '../views/modules/Login/Login.vue';
import NewPassword from '../views/modules/NewPassword/NewPassword.vue';
import UserManagement from '../views/modules/User/UserManagement/UserManagement.vue';
import UserDetail from '../views/modules/User/UserDetail/UserDetail.vue';
import InvestorManagement from '../views/modules/Investor/InvestorManagement/InvestorManagement.vue';
import InvestorDetail from '../views/modules/Investor/InvestorDetail/InvestorDetail.vue';
import OriginatorManagement from '../views/modules/Originator/OriginatorManagement/OriginatorManagement.vue';
import OriginatorDetail from '../views/modules/Originator/OriginatorDetail/OriginatorDetail.vue';
import OfferManagement from '../views/modules/Offer/OfferManagement/OfferManagement.vue';
import OfferDetail from '../views/modules/Offer/OfferDetail/OfferDetail.vue';
import AdministratorManagement from '../views/modules/Administrator/AdministratorManagement/AdministratorManagement.vue';
import OfferStatusManagement from '../views/modules/OfferStatus/OfferStatusManagement/OfferStatusManagement.vue';
import OfferStatusDetail from '../views/modules/OfferStatus/OfferStatusDetail/OfferStatusDetail.vue';
import AdministratorDetail from '../views/modules/Administrator/AdministratorDetail/AdministratorDetail.vue';
import OperationTypeManagement from '../views/modules/Operation/OperationTypeManagement/OperationTypeManagement.vue';
import OperationTypeDetail from '../views/modules/Operation/OperationTypeDetail/OperationTypeDetail.vue';
import IndustryManagement from '../views/modules/Industry/IndustryManagement/IndustryManagement.vue';
import IndustryDetail from '../views/modules/Industry/IndustryDetail/IndustryDetail.vue';
import DocTypeManagement from '../views/modules/DocType/DocTypeManagement/DocTypeManagement.vue';
import DocTypeDetail from '../views/modules/DocType/DocTypeDetail/DocTypeDetail.vue';
import DocSubtypeManagement from '../views/modules/DocSubtype/DocSubtypeManagement/DocSubtypeManagement.vue';
import DocSubtypeDetail from '../views/modules/DocSubtype/DocSubtypeDetail/DocSubtypeDetail.vue';
import OfferReport from '../views/modules/Offer/OfferReport/OfferReport.vue';
import Structurer from '../views/modules/Structurer/Structurer.vue';
import Config from '../views/modules/Config/Config.vue';
import StructurerDetail from '@/components/modules/Structurer/StructurerDetail/StructurerDetail.vue';
import FileUpload from '../views/modules/FileUpload/FileUpload.vue';

Vue.use(VueRouter);

export const routes = [
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: Dashboard,
		redirect: '/dashboard/analytics',
		children: [
			{
				path: '/dashboard/analytics',
				name: 'Analytics',
				menuLabel: 'Analytics',
				component: Analytics,
			},
			{
				path: '/dashboard/users',
				name: 'Usuários',
				menuLabel: 'Usuários',
				component: UserManagement,
			},
			{
				path: '/dashboard/user/detail',
				name: 'Detalhe Usuário',
				menuLabel: 'Detalhe Usuário',
				component: UserDetail,
			},
			{
				path: '/dashboard/investors',
				name: 'Investidores',
				menuLabel: 'Investidores',
				component: InvestorManagement,
			},
			{
				path: '/dashboard/investor/detail',
				name: 'Detalhe Investidor',
				menuLabel: 'Detalhe Investidor',
				component: InvestorDetail,
			},
			{
				path: '/dashboard/structurer',
				name: 'Estruturadores',
				menuLabel: 'Estruturadores',
				component: Structurer,
			},
			{
				path: '/dashboard/structurer/detail',
				name: 'Editar Estruturador',
				component: StructurerDetail,
			},
			{
				path: '/dashboard/originators',
				name: 'Originadores',
				menuLabel: 'Originadores',
				component: OriginatorManagement,
			},
			{
				path: '/dashboard/originator/detail',
				name: 'Detalhe Originador',
				menuLabel: 'Detalhe Originador',
				component: OriginatorDetail,
			},
			{
				path: '/dashboard/offers',
				name: 'Ofertas',
				menuLabel: 'Ofertas',
				component: OfferManagement,
			},
			{
				path: '/dashboard/offer/detail',
				name: 'Detalhe Oferta',
				menuLabel: 'Detalhe Oferta',
				component: OfferDetail,
			},
			{
				path: '/dashboard/offer/upload/:originatorId/:offerId',
				name: 'FileUpload',
				menuLabel: 'Upload de arquivos',
				component: FileUpload,
				props: true,
			},
			{
				path: '/dashboard/offer/:id',
				name: 'offer-report',
				component: OfferReport,
			},
			{
				path: '/dashboard/offerStatus/detail',
				name: 'Detalhe Status da Oferta',
				menuLabel: 'Detalhe Status da Oferta',
				component: OfferStatusDetail,
			},
			{
				path: '/dashboard/config',
				name: 'Configurações',
				menuLabel: 'Configurações',
				component: Config,
				redirect: '/dashboard/config/industryType',
			},
			{
				path: '/dashboard/config/industryType',
				name: 'Indústrias',
				menuLabel: 'Indústrias',
				component: IndustryManagement,
			},
			{
				path: '/dashboard/config/operationType/detail',
				name: 'Detalhe Tipo de Operação',
				menuLabel: 'Detalhe Tipo de Operação',
				component: OperationTypeDetail,
			},
			{
				path: '/dashboard/config/docType',
				name: 'Tipo de Documento',
				menuLabel: 'Tipo de Documento',
				component: DocTypeManagement,
			},
			{
				path: '/dashboard/config/offerStatus',
				name: 'Status da Oferta',
				menuLabel: 'Status da Oferta',
				component: OfferStatusManagement,
			},
			{
				path: '/dashboard/config/operationType',
				name: 'Tipo de Operação',
				menuLabel: 'Tipo de Operação',
				component: OperationTypeManagement,
			},
			{
				path: '/dashboard/config/docSubtype',
				name: 'Subtipo de Documentos',
				menuLabel: 'Subtipo de Documentos',
				component: DocSubtypeManagement,
			},
			{
				path: '/dashboard/config/docType/detail',
				name: 'Detalhe Tipo de Documento',
				menuLabel: 'Detalhe Tipo de Documento',
				component: DocTypeDetail,
			},
			{
				path: '/dashboard/config/docSubtype/detail',
				name: 'Detalhe Subtipo de Documentos',
				menuLabel: 'Detalhe Subtipo de Documentos',
				component: DocSubtypeDetail,
			},
			{
				path: '/dashboard/config/industryType/detail',
				name: 'Detalhe da Indústria',
				menuLabel: 'Detalhe da Indústria',
				component: IndustryDetail,
			},
			{
				path: '/dashboard/admin/detail',
				name: 'Detalhe Configuração',
				menuLabel: 'Detalhe Configuração',
				component: AdministratorDetail,
			},
			{
				path: '/dashboard/admins',
				name: 'Administradores',
				menuLabel: 'Administradores',
				component: AdministratorManagement,
			},
		],
	},
	{
		path: '/login',
		name: 'Login',
		component: Login,
	},
	{
		path: '/password/reset',
		name: 'NewPassword',
		component: NewPassword,
	},
	{
		path: '*',
		redirect: '/login',
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});

export default router;
